import { translatePortuguese } from "@/data/portuguese-core";
import { pageUrl, type SiteLang } from "@/lib/lang-url";

type CoreHead = { meta: Array<{ content?: string; title?: string; name?: string; property?: string }> };

/** Localize only the first delivery's routes, leaving other route heads intact. */
export function localizedCoreHead<T extends CoreHead>(path: string, lang: SiteLang, head: T): T {
  return {
    ...head,
    meta: head.meta.map((meta) => {
      if (meta.property === "og:url") return { ...meta, content: pageUrl(path, lang) };
      if (meta.title) return { ...meta, title: translatePortuguese(meta.title, lang) };
      if (meta.content && ["description", "og:title", "og:description"].includes(meta.name ?? meta.property ?? "")) {
        return { ...meta, content: translatePortuguese(meta.content, lang) };
      }
      return meta;
    }),
  };
}